import React from 'react';
import { withRouter, Link } from 'react-router'
import { Button, Dialog, DialogActions, DialogContent, DialogTitle } from '@material-ui/core';
import { isMobile } from 'react-device-detect';
import config from '../../../config'
import { assetsValue } from '../../../constants';
const LeaseStatusError = ({ params, activeLeaseModal, toggleModalFn }) => {
  const userDetail = JSON.parse(localStorage.getItem('userInfo'));
  const isLessorMatched = config.lessorIds?.includes(userDetail?.defaultLessor?.id) ?? false
  const redirectURI = activeLeaseModal?.error?.data?.lease_slug
    ? isLessorMatched
      ? `${config.domain.leaseRevamp}lease/${activeLeaseModal.error.data.lease_slug}/lease-details/headlines`
      : `${config.domain.lease}${params.type}/${params.aircraft_slug}/contract/list/${activeLeaseModal.error.data.lease_slug}/`
    : isLessorMatched
      ? `${config.domain.leaseRevamp}assets/${assetsValue[params.type]}/${params.type === "lg" ? "landing_gear" :params.type }/${params.aircraft_slug}/leases`
      : `${config.domain.lease}${params.type}/${params.aircraft_slug}/contracts`;
  return (
    <div >
      <Dialog
        open={activeLeaseModal.modal}
        onClose={toggleModalFn}
        aria-labelledby="scroll-dialog-title"
      >
        <DialogTitle id="scroll-dialog-title">
          Redirect to Lease
        </DialogTitle>
        <DialogContent dividers={true}>
          <div style={isMobile ? { width: 'auto' } : { minWidth: '400px' }}>
            <div className="">
              {activeLeaseModal?.error?.message || ''}
              <p><a href={redirectURI} target="_blank" rel="noopener noreferrer">
                Click Here to Redirect to Lease
              </a></p>
            </div>
          </div>
        </DialogContent>
        <DialogActions >
          <Button style={{ float: 'inline-end' }} size='small' variant="outlined" onClick={toggleModalFn} color={'primary'}>Cancel</Button>
        </DialogActions>
      </Dialog>
    </div>
  )
}
export default withRouter(LeaseStatusError);
